import { api } from './api';
import type { DriveNode, FolderResp } from './types';

/**
 * A folder's contents. The server sends them in pages (DZ-250: a folder with 10,000 files no longer
 * ties up the server while every row is read); `onPage` gets the first page at once and every later
 * page as it arrives, with all children so far. `stop()` ends the walk (the person left the folder).
 */
export async function loadFolder(id: string, onPage?: (r: FolderResp) => void, stop: () => boolean = () => false): Promise<FolderResp> {
  const first = await api<FolderResp>(`/api/folders/${id}`);
  let all: DriveNode[] = first.children;
  let next = first.nextCursor ?? null;
  onPage?.({ ...first, children: all });
  while (next && !stop()) {
    const page = await api<FolderResp>(`/api/folders/${id}?cursor=${encodeURIComponent(next)}`);
    if (stop()) break;
    all = all.concat(page.children);
    next = page.nextCursor ?? null;
    onPage?.({ ...first, children: all });
  }
  return { ...first, children: all, nextCursor: null };
}
